import { getSnapshot, types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { IValueChange } from '@/pages/supplier/listing/definition/accountDetails'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

const EventListModel = types.model('EventListModel').props({
  id: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  startDate: types.maybeNull(types.string),
  endDate: types.maybeNull(types.string),
  link: types.maybeNull(types.string),
  status: types.optional(types.string, 'draft'),
})

export const EventModel = types
  .model('EventModel')
  .props({
    events: types.optional(types.array(EventListModel), []),
    listing_setup_step: types.optional(types.number, 8),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }

    const mapValueChanged = ({ add, value: { events } }: IValueChange) => {
      if (add === 'add') {
        self.events = events
        setStatus('changed')
      }
    }

    const update = async (id: string, data: any = null) => {
      const remapData = getSnapshot(self.events) as any[]
      const isAllowSavePreValue = Object.entries(remapData).every(
        (item: any) => item[1] && item[1].length > 0
      )
      const URI = `${DOMAIN_ACTION.API.UPDATE_SUPPLIER_LISTING(id)}`
      const newPayload = remapData.map((item: any) => ({
        ...item,
        status: 'submit',
      }))
      const reduceData = isAllowSavePreValue
        ? newPayload
        : newPayload.filter(
            (item: any) => item.title !== '' || item.description !== ''
          )

      const payload = {
        listing_setup_step: self.listing_setup_step,
        events: reduceData,
      }

      const { promotions } = data || { promotions: [] }
      const paramData = isAllowSavePreValue ? remapData : [...promotions]
      const mapData = { ...data, events: paramData }
      const res = await axios.put(URI, data ? mapData : payload)
      return res
    }

    return { setStatus, mapValueChanged, update }
  })
